import React, { ReactElement } from 'react';
import './Quiz.scss';
import Header from '@/pages/Module/components/Header';
import { Layout } from 'elmo-elements';
import { useParams } from 'react-router-dom';
import { ElearningParamType } from '@/pages/Module/routes';
import { useGetQuizQuery, useGetThemesQuery } from '@/modules/services';
import { useErrorHandler } from 'react-error-boundary';
import QuizSideBar from './components/QuizSidebar';
import QuizSetup from './components/quizSetup';

const QuizComponent = (): ReactElement => {
  const handleError = useErrorHandler();
  const { elearningId } = useParams<ElearningParamType>();

  const quiz = useGetQuizQuery(elearningId);
  const themes = useGetThemesQuery();

  if (quiz.isError) {
    handleError(quiz.error);
  }

  if (themes.isError) {
    handleError(themes.error);
  }

  return (
    <>
      <Layout.Header>
        <Header />
      </Layout.Header>
      <div className="editor-layout__body">
        <QuizSideBar />
        <Layout.Content>
          <div className="center-content">
            {quiz.isLoading ? <div className="loading" /> : <QuizSetup />}
          </div>
        </Layout.Content>
      </div>
    </>
  );
};

export default QuizComponent;
